import React from 'react';
import PropTypes from 'prop-types';

import Kinostyles from '../../Util/LandingPageStylesComponent.module.css';

const H1FlohmarktSchrift = props => {
  const { color, text, centered, invisible } = props;

  const getColorClass = () => {
    switch (color) {
      case 'black':
        return Kinostyles.BrandonHeadlineBlack;
      case 'yellow':
        return Kinostyles.BrandonHeadlineYellowNoAlign;
      case 'pink':
        return Kinostyles.BrandonHeadlineRosa;
      case 'green':
        return Kinostyles.BrandonHeadlineGreen;
      default:
        return Kinostyles.BrandonHeadlineBlack;
    }
  };

  const isVisibleClass = () => {
    if (invisible) {
      return Kinostyles.Invisible;
    } else {
      return '';
    }
  };

  return (
    <>
      {centered ? (
        <div className={Kinostyles.CenterContent}>
          <h1
            className={
              getColorClass() +
              ' ' +
              Kinostyles.lpHeading +
              ' ' +
              isVisibleClass()
            }
          >
            {text}
          </h1>
        </div>
      ) : (
        <h1
          className={
            getColorClass() +
            ' ' +
            Kinostyles.lpHeading +
            ' ' +
            Kinostyles.LeftContent +
            ' ' +
            isVisibleClass()
          }
        >
          {text}
        </h1>
      )}
    </>
  );
};

H1FlohmarktSchrift.propTypes = {
  color: PropTypes.string,
  text: PropTypes.string,
  centered: PropTypes.bool,
  invisible: PropTypes.bool,
};

export default H1FlohmarktSchrift;
